import { GetCrmoPendencyCounters } from 'domain/usecases/surgical-order/get-crmo-pendency-counters'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteGetCrmoPendencyCounters implements GetCrmoPendencyCounters {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  count(
    params: GetCrmoPendencyCounters.Params
  ): Promise<GetCrmoPendencyCounters.Model> {
    return this.surgicalOrderRepository.getCrmoPendencyCounters(params)
  }
}
